"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabPaginationDirection = exports.EmeraldTabData = void 0;
class EmeraldTabData {
    constructor(label, icon, disabled = false) {
        this.label = label;
        this.icon = icon;
        this.disabled = disabled;
        this.hasBadge = false;
        this.isTabInstance = true;
        this.isTabActive = false;
    }
}
exports.EmeraldTabData = EmeraldTabData;
var TabPaginationDirection;
(function (TabPaginationDirection) {
    TabPaginationDirection["PREVIOUS"] = "previous";
    TabPaginationDirection["NEXT"] = "next";
})(TabPaginationDirection || (exports.TabPaginationDirection = TabPaginationDirection = {}));
//# sourceMappingURL=tab.data.js.map